module.exports = __webpack_public_path__ + "static/LaptopPlatformPR-2e0de6cd77b984cbe86b911b5cc28796.mp4";